
import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Facebook, Twitter, Linkedin, Mail, Link, Copy, Check } from 'lucide-react';

interface ArticleShareOptionsProps {
  articleId?: string;
  onShare?: () => void;
}

const ArticleShareOptions: React.FC<ArticleShareOptionsProps> = ({ articleId, onShare }) => {
  const [copied, setCopied] = useState(false);
  const articleUrl = `https://directpress.com/article/${articleId || '1'}`;
  
  const handleCopyLink = () => {
    navigator.clipboard.writeText(articleUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    
    if (onShare) {
      onShare();
    }
  };
  
  const handleSocialShare = (platform: string) => {
    // In a real app, this would open a share dialog for the respective platform
    console.log(`Sharing to ${platform}`);
    
    if (onShare) {
      onShare();
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-6">Share this article</h2>
      
      <Tabs defaultValue="social" className="w-full">
        <TabsList className="grid grid-cols-2 mb-4">
          <TabsTrigger value="social">Social</TabsTrigger>
          <TabsTrigger value="link">Copy Link</TabsTrigger>
        </TabsList>
        
        <TabsContent value="social">
          <div className="grid grid-cols-2 gap-4 mb-4">
            <Button 
              variant="outline" 
              className="flex items-center gap-2 justify-center"
              onClick={() => handleSocialShare('twitter')}
            >
              <Twitter className="h-4 w-4" />
              Twitter
            </Button>
            
            <Button 
              variant="outline" 
              className="flex items-center gap-2 justify-center"
              onClick={() => handleSocialShare('facebook')}
            >
              <Facebook className="h-4 w-4" />
              Facebook
            </Button>
            
            <Button 
              variant="outline" 
              className="flex items-center gap-2 justify-center"
              onClick={() => handleSocialShare('linkedin')}
            >
              <Linkedin className="h-4 w-4" />
              LinkedIn
            </Button>
            
            <Button 
              variant="outline" 
              className="flex items-center gap-2 justify-center"
              onClick={() => handleSocialShare('email')}
            >
              <Mail className="h-4 w-4" />
              Email
            </Button>
          </div>
        </TabsContent>
        
        <TabsContent value="link">
          <div className="space-y-4">
            <div className="flex">
              <Input 
                value={articleUrl} 
                readOnly 
                className="rounded-r-none"
              />
              <Button 
                className="rounded-l-none"
                onClick={handleCopyLink}
              >
                {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
              </Button>
            </div>
            
            <p className="text-sm text-muted-foreground">
              Copy the link to share this article directly with others.
            </p>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ArticleShareOptions;
